import clsx from 'clsx'
import type { HTMLAttributes, ReactNode } from 'react'

export interface EmptyStateProps {
  title: string
  description?: string
  action?: ReactNode
  className?: string
}

/** Zentrierter Leerzustand für Listen, Panels oder Tabellen-Inhalte. */
export function EmptyState({ title, description, action, className }: EmptyStateProps) {
  return (
    <div className={clsx('py-10 px-4 text-center', className)}>
      <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{title}</p>
      {description ? (
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{description}</p>
      ) : null}
      {action ? <div className="mt-4 flex justify-center">{action}</div> : null}
    </div>
  )
}

export interface EmptyTableRowProps extends Pick<EmptyStateProps, 'title' | 'description'> {
  colSpan: number
  className?: string
}

/** Eine Tabellenzeile mit zentriertem Leerzustand (übliches `colSpan`). */
export function EmptyTableRow({ colSpan, title, description, className }: EmptyTableRowProps) {
  return (
    <tr>
      <td colSpan={colSpan} className={clsx('px-6 py-2', className)}>
        <EmptyState title={title} description={description} className="py-8" />
      </td>
    </tr>
  )
}
